module.exports = __webpack_public_path__ + "img/sample-error-1.83c357d.webp";